import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Search, Grid, User, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const Item = ({ to, icon: Icon, label, testid, onClick }) => (
  <NavLink
    to={to}
    onClick={onClick}
    data-testid={testid}
    className={({ isActive }) =>
      `flex flex-col items-center justify-center gap-0.5 flex-1 py-2 ${isActive ? "text-[#D81B60]" : "text-[#8E6377]"}`
    }
  >
    <Icon size={20} />
    <span className="text-[10px] font-medium">{label}</span>
  </NavLink>
);

export const BottomNav = () => {
  const { itemCount, setIsOpen } = useCart();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-t border-[#F4D8E2] flex items-center pb-[env(safe-area-inset-bottom)]"
    >
      <Item to="/" icon={Home} label="Home" testid="nav-bottom-home" />
      <Item to="/shop" icon={Search} label="Shop" testid="nav-bottom-shop" />
      <Item to="/custom" icon={Grid} label="Custom" testid="nav-bottom-custom" />
      <Item to="/about" icon={User} label="About" testid="nav-bottom-about" />
      <button
        data-testid="nav-bottom-cart"
        onClick={() => setIsOpen(true)}
        className="flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-[#8E6377] relative"
      >
        <ShoppingBag size={20} />
        <span className="text-[10px] font-medium">Cart</span>
        {itemCount > 0 && (
          <span className="absolute top-1 right-4 bg-[#D81B60] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
            {itemCount}
          </span>
        )}
      </button>
    </nav>
  );
};
